import React, {useEffect, useState} from "react";
import QnectTextField from "../qnect-ui/qnect-text-field";
import QnectDateField from "../qnect-ui/qnect-date-field";
import QnectSelectField from "../qnect-ui/qnect-select-field";
import FieldWrapper from "../custom/field-wrapper";
import QnectButton from "../qnect-ui/qnect-button";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "../custom/dialog-title";
import DialogSecondaryTitle from "../custom/dialog-secondary-title";
import Dialog from '../custom/dialog';
import {useDialogStyles} from "../custom/dialog-style";
import useConfig from "../qnect-ui/qnect-config";
import {
    _convertStringDateToMomentObject,
    _formatDate,
    _generateUuid,
    _masked,
    _validateForm, isParentMember
} from "../../utils/utility";
import moment from "moment";
import {DialogContentText} from "@material-ui/core";

export const DeleteUserDialog = ({open = false, onClose, onOk, heading, parentOptions, data, ...props}) => {
    const classes = useDialogStyles();
    const cfg = useConfig();
    const formId = 'deleteUserForm';
    const [lastServiceDate, setLastServiceDate] = useState(null);
    const [lastServiceDateErrorMessage, setLastServiceDateErrorMessage] = useState(null);
    const currentDate = moment(new Date(), 'DD/MM/YYYY');
    const [allowDelete, setAllowDelete] = useState(true);

    useEffect(() => {
        if (open) {
            setLastServiceDate(null);
            setLastServiceDateErrorMessage(null);
            // Check if data is newly added if so allow delete
            setAllowDelete(data?.allowDelete)
        }
    },[open])

    const onClickOk = () => {
        let obj = {
            ...data,
            recordIdx: data.tableData.id,
        }
        obj.tempId = data.tempId ? data.tempId : _generateUuid();

        if (data.memberNo && _validateForm(formId) && validateLastServiceDate()) {
            obj.action = 'D';
            obj.lastServiceDate = _formatDate(lastServiceDate);
            onOk(obj);
        } else if (!data.memberNo) {
            onOk(obj)
        }
    }

    const validateLastServiceDate = () => {
        let empDate = moment(data.employmentDate, 'DD/MM/YYYY');
        if (lastServiceDate.isBefore(empDate)) {
            setLastServiceDateErrorMessage(cfg('lastServiceDateUser.errorMessages.serviceDateBeforeEmpDate'));
            return false;
        }
        if (currentDate.diff(lastServiceDate, 'days') > 90) {
            setLastServiceDateErrorMessage(cfg('lastServiceDateUser.errorMessages.lastDayServiceMoreThan90'));
            return false;
        }

        return true;
    }

    return (
        <div>
            <Dialog open={open} onClose={onClose} className={classes.modal_box_container}>
                <DialogTitle className={classes.title}
                    title={cfg("policyDetailModals.deleteUser.title")}
                    onClose={onClose} lang={props.lang}
                />
                <DialogSecondaryTitle title={heading} />
                <DialogContent>
                     <div className={classes.modal_box_form_container}>
                         <div className='modal_box_form_field input_relationship'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     formId={formId}
                                     field="relationshipUser"
                                     value={data?.relationship}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         {
                             !isParentMember(data?.memberNo) &&
                             <div className='modal_box_form_field input_relationship'>
                                 <FieldWrapper >
                                     <QnectSelectField
                                         field="parentMembers"
                                         value={data?.parentMember}
                                         errorMessage=''
                                         onChange=''
                                         placeholder=''
                                         options={parentOptions}
                                         disabled={true}
                                     />
                                 </FieldWrapper>
                             </div>
                         }
                         {
                             isParentMember(data?.memberNo) &&
                             <div className='modal_box_form_field input_employmentDate'>
                                 <FieldWrapper >
                                     <QnectDateField
                                         field="employmentDateUser"
                                         value={_convertStringDateToMomentObject(data?.employmentDate)}
                                         disabled={true}
                                     />
                                 </FieldWrapper>
                             </div>
                         }
                         <div className='modal_box_form_field input_name'>
                             <FieldWrapper >
                                 <QnectTextField
                                     formId={formId}
                                     field="nameUser"
                                     value={data?.name}
                                     disabled={true}
                                     label={ data?.relationship !== '00' ? cfg('genericLabels.dependentNameLabel') : null}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_effectiveDate'>
                             <FieldWrapper >
                                 <QnectDateField
                                     field="effectiveDateUser"
                                     value={_convertStringDateToMomentObject(data?.effectiveDate)}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                       </div>
                         <div className='modal_box_form_field input_dobDate'>
                             <FieldWrapper >
                                 <QnectDateField
                                     field="dateOfBirthUser"
                                     value={_convertStringDateToMomentObject(data?.dateOfBirth)}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_nricPassport'>
                             <FieldWrapper >
                                 <QnectTextField
                                     formId={formId}
                                     field="nricPassportUser"
                                     value={_masked(data?.securityId)}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         {
                             data?.memberNo &&
                             <div className='modal_box_form_field input_lastServiceDate'>
                                <FieldWrapper >
                                    <QnectDateField
                                        formId={formId}
                                        field="lastServiceDateUser"
                                        value={lastServiceDate}
                                        errorMessage={lastServiceDateErrorMessage}
                                        disabled={!allowDelete}
                                        onChange={(val) => {
                                            setLastServiceDateErrorMessage(null);
                                            setLastServiceDate(val);
                                        }}
                                    />
                                </FieldWrapper>
                            </div>
                         }
                         <div className='modal_box_form_field input_gender'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     formId={formId}
                                     field="genderUser"
                                     value={data?.gender}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_email'>
                             <FieldWrapper >
                                 <QnectTextField
                                     formId={formId}
                                     field="emailAddress"
                                     value={data?.emailAddress}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                     </div>
                    { !allowDelete && <DialogContentText className="NonModifyMessage">
                        We regret to inform you that we are unable to proceed as changes for the next Renewal period, it must be submitted through Renewal instructions. <br/><br/>For
                        further assistance, you may contact us at <a href="mailto:acchealthupdate.sg@qbe.com">acchealthupdate.sg@qbe.com</a>.
                    </DialogContentText>
                    }
                </DialogContent>
                <DialogActions className={classes.actions}>
                        <QnectButton onClick={onClose} field="cancel"/>
                        <QnectButton onClick={() => onClickOk()} field="confirm" disabled={!allowDelete}/>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default DeleteUserDialog;
